module.exports = __webpack_public_path__ + "assets/img/hero-overview.68c95009.jpg";